<!-----------------------------------------------------------------------------
  - Copyright (c) 2018. keni <$email>                                         -
  -                                                                           -
  - This file TicketDetailsList.vue is part of event_pass_client.dev.         -
  - Unauthorized copying of this file, via any medium is strictly prohibited. -
  - Proprietary and confidential                                              -
  - TicketDetailsList.vue can not be copied and/or distributed                -
  - without the express permission of keni                                    -
  ----------------------------------------------------------------------------->

<!--//Created by keni.-->
<!--//User: keni-->
<!--//Date: 22/03/2018-->
<!--//Time: 17:17-->

<template>
    <div data-ref="ticket-details-list" class="cursor-pointer"
         @click="showDescription(ticket)"
    >
        <div class="d-flex">
            <div class="d-inline-block ">
                <InfoButton></InfoButton>
            </div>
            <div class="d-inline-block mb-0 align-self-center">
                    <!--the title-->
                    <div class="d-flex justify-content-start">
                        <i :class="ticketTypeIconClass(ticket)"
                           class="mr-2 fs-5 align-self-center"
                           v-if="local_show_icon === true"
                        />
                        <!--{{debug('ticket',ticket)}}-->
                        <span class="align-self-center">
                            <span>{{lang('title',ticket.ticket_data.lang)}}</span>
                        <span v-if="bundle_title !== ''" class="text-right small text-muted"><br><span
                                class="font-italic">part of </span>{{bundle_title}}</span>
                        </span>

                    </div>
                <!--the time-->
                <!--
                    <span class="text-muted d-block d-md-inline-block"
                          v-if="show_time && hasOpenTime">
                            <small :class="{
                                'sold_out':sold_out
                            }">
                               <span class="d-inline">access between </span>
                                <span class="d-flex flex-nowrap">{{hasOpenTime}} - {{getClose}}</span>
                            </small>
                        </span>
                        -->
                </div>
        </div>

    </div>
</template>

<script>
    import {length} from '../../../../../app/Shared/Resources/Assets/js/helpers/object.formats';
    import {getDate, DATE_FORMAT} from '../../../../../app/Shared/Resources/Assets/js/helpers/format.date';
    import {ticket_types} from '../../../../../app/Shared/Resources/Assets/js/helpers/ticketIcons';
    import lang from '../../../../../app/Shared/Resources/Assets/js/helpers/lang';
    import {getUrl} from '../../../../../app/Shared/Resources/Assets/js/helpers/routes';
    import {isPastDate} from 'date-fns/is_past';
    import {stringToProperty} from '../../../../../app/Shared/Resources/Assets/js/helpers/object.formats'

    Vue.component('round-button', require('../../../../../app/Shared/Resources/Assets/js/components/buttons/RoundButton'));

    export default {
        name: "ticket-details-list",
        components: {},
        props: {
            bundle_title: {
                type: String,
                default: ''
            },
            /**
             * @property ticket_type
             * @property ticket_data
             * @namespace
             */
            ticket: Object,
            show_icon: {
                type: Boolean,
                default: null
            },
            show_time: Boolean,
            description_event: Boolean,
            sold_out: {
                type: Boolean,
                default: false
            },
            sold_out_tickets: Object,
            ticket_route: {
                type: Object,
                default: function () {
                    return {};
                }
            },

        },
        created() {
        },
        destroyed() {
        },
        mounted() {
            if (this.ticket.ticket_type == 'season') {
                // console.log('mounted', 'this.ticket', this.ticket);
            }
// console.log('mounted', 'this.show_time',this.show_time);
            if (this.show_icon == null) {
                this.local_show_icon = true;
            } else {
                this.local_show_icon = this.show_icon;
            }
        },
        data() {
            return {
                show_long_desc: false,
                local_show_icon: false,
            }
        },
        methods: {
            log(...arg) {
                console.log(...arg);
            },
            /**
             * Lists the events that are attached to this ticket purchase
             **/
            listEvents(ticket) {
// console.log('listEvents', 'ticket.events',ticket.events);
                let self = this,
                    events = '',
                    eventsSorted = ticket.events.sort(function compare(a, b) {
                        var date_a = new Date(a.start_date);
                        var date_b = new Date(b.start_date);

                        return date_a - date_b;
                    });

                eventsSorted = eventsSorted.reverse();

                // console.log('listEvents', 'ticket.events',ticket.events);
// console.log('listEvents',ticket.events, 'eventsSorted',eventsSorted);
                for (let eventsKey in eventsSorted) {

                    /**
                     * @param {Object} event.event_data.lang
                     * @param {Object} event.event_data
                     * @param {Object} event
                     */
                    let event = ticket.events[eventsKey],
                        eventName = lang('title', event.event_data.lang),
                        start_date = (typeof event.start_date !== 'undefined' && event.start_date !== null)
                                     ? getDate(event.start_date)
                                     : 'TBA',
                        urlDate = (typeof event.start_date !== 'undefined' && event.start_date !== null)
                                  ? getDate(event.start_date, DATE_FORMAT.url_date)
                                  : 'tba',
                        link = '',
                        listElement = 'div';
// console.log('event.start_date',event.start_date);

                    // strike off event listing because its not a tba and has expired
                    if (start_date !== 'TBA') {
                        if (new Date(event.start_date) < new Date()) {
                            listElement = 's';
                        }
                    }

                    let paramsData = self.createRoutePrams({
                        category: event.category.slug,
                        date: urlDate.toLowerCase(),
                        slug: event.slug
                    });

                    if (paramsData != null) {
                        link = getUrl(self.ticket_route.pattern, paramsData.params);
                    }

                    // console.log('listEvents', 'link', link);
                    events = `${events}
<div class="list-group-item list-group-item-action">
    <a class="text-body w-100"
        ${link !== '' ? `href="${link}"` : ''}
    >
        <${listElement} class="d-flex justify-content-between align-items-center ">
            <span>${eventName}</span>
            <span>${start_date}</span>
        </${listElement}>
    </a>
</div>`;

                    // console.log('listEvents', 'paramsData', paramsData);

                }

                self.show_long_desc = !self.show_long_desc;
                self.$emit('show_ticket_description', {
                    set_active: self.show_long_desc,
                    id: ticket.id,
                    description: `
<div class="list-group borderless">
    <div class="list-group-item bg-primary">
        <div class="w-100 d-flex justify-content-between align-items-center ">
            <span>Event</span>
            <span>Date</span>
        </div>
    </div>
    ${events}
</div>`
                });

            },
            createRoutePrams(item) {
                let self = this;

                // console.log('createRoutePrams', 'rec', self.ticket_route);

                if (typeof self.ticket_route !== 'undefined' && self.ticket_route !== null) {
                    let params = {
                        route: self.ticket_route.route,
                        params: {}
                    };
                    if ('params' in self.ticket_route) {
                        for (let i = 0; i < self.ticket_route.params.refs.length; i++) {
                            let paramsReference = self.ticket_route.params.refs[i];
// console.log('createRoutePrams', 'paramsReference->'+paramsReference,item[paramsReference]);
                            params.params[paramsReference] = item[paramsReference];
                        }
                    }
                    return params;
                } else {
                    return null;
                }

            },
            showDescription(ticket) {
                let self = this;
                // console.log('showDescription', 'self.description_event', self.description_event, this.ticket.ticket_type);
                if (typeof self.description_event !== 'undefined' && self.description_event !== false) {
                    // console.log('showDescription', 'this.ticket.ticket_type', this.ticket.ticket_type);
                    self.listEvents(ticket);
                } else {
                    let
                        short = lang('description', ticket.ticket_data.lang).short || '',
                        long = lang('description', ticket.ticket_data.lang).long || '';

                    self.show_long_desc = !self.show_long_desc;
                    self.$emit('show_ticket_description', {
                        set_active: self.show_long_desc,
                        id: ticket.id,
                        description: `<div class="p-2">${short}</div><div class="p-2">${long}</div>`
                    });
                }

            },
            debug() {
                if (typeof (console) !== 'undefined') {
                    console.log.apply(console, arguments);
                }
            },
            displayLongDescription() {

            },
            displayTime() {
                return (typeof this.show_time !== 'undefined' && this.show_time !== null) ? this.show_time : false;
            },
            /**
             * Checks the date set from the ticket event attributes first. If not found then we get the value from
             * the entity itself
             * @property ticket.open_close_full_ticket_event_attributes
             *
             * @property ticket.entity.entity_type_data.input_fields.groups.open_close_full
             * @property ticket.entity.entity_type_data.input_fields.groups
             * @property ticket.entity.entity_type_data.input_fields
             * @property ticket.ticket_event_attributes
             * @property String ticket.entity.entity_type_data
             * @property ticket.entity
             * @namespace ticket
             * @param ticket
             * @param position
             * @returns {*}
             * @todo must add other type configs to this
             */
            setDate(ticket, position) {
                let hasAttributes, eData;

                // validate if the ticket has custom attributes first
                if (typeof ticket.ticket_event_attributes !== 'undefined' && ticket.ticket_event_attributes !== null) {
                    /**
                     * @property hasAttributes.ticket_event_attribute_data
                     * @namespace
                     * @type {null}
                     */
                    // console.log('setDate', 'typeof ticket.ticket_event_attributes',typeof ticket.ticket_event_attributes);
                    hasAttributes = ticket.ticket_event_attributes;
                } else if (typeof ticket.open_close_full_ticket_event_attributes !== 'undefined' && ticket.open_close_full_ticket_event_attributes !== null) {
                    /**
                     * @property hasAttributes.ticket_event_attribute_data
                     * @namespace
                     * @type {null}
                     */
                    // console.log('setDate', 'typeof ticket.ticket_event_attributes',typeof ticket.ticket_event_attributes);
                    hasAttributes = ticket.open_close_full_ticket_event_attributes;
                } else {
                    /**
                     * @property hasAttributes.ticket_event_attribute_data
                     * @namespace
                     * @type {null}
                     */
                    hasAttributes = null;
                }
                // attributes were found for the current entity so lets get them
                if (typeof hasAttributes !== 'undefined' && hasAttributes !== null) {
                    // console.log('setDate',ticket,'position->'+position,hasAttributes.ticket_event_attribute_data);

                    // find attribute in event attributes first. if not found we will try for the entity then

                    // if not found look in ticket finally
// console.log(hasAttributes,hasAttributes.ticket_event_attribute_data[position])

                    if (typeof hasAttributes.ticket_event_attribute_data[position] === 'undefined') {
                        return null;
                    }
                    return hasAttributes.ticket_event_attribute_data[position].value;
                }
                // no attributes found so lets look in the entity
                else {
                    // console.log('setDate', 'ticket.entity',JSON.parse(ticket.entity.entity_type_data));
                    if ('entity_type_data' in ticket.entity) {
                        eData = ticket.entity.entity_type_data;
                    } else {
                        eData = ticket.entity.entity_data.entity_type.entity_type_data;
                    }
                    if (typeof eData == 'string') {
                        eData = JSON.parse(eData);
                    }
                    // console.log('setDate', 'eData', eData, typeof eData);
                    let test = stringToProperty('input_fields.groups.open_close_full.items', eData);
                    if (typeof test !== 'undefined' && test !== null) {
                        // console.log('setDate', 'test',test);
                        return eData.input_fields.groups.open_close_full.items[position].value
                    }
                    return null;
                }

            },
            lang(path, object) {
                // console.log('object',object);
                return lang(path, object)
            },
            ticketTypeIconClass(ticket) {
                return ticket_types(ticket.ticket_type, false);
            },
        },
        computed: {
            hasOpenTime() {
                return this.setDate(this.ticket, 'open_time');
            },
            getClose() {
                return this.setDate(this.ticket, 'close_time')
            }
        }
    }
</script>

<style scoped>
    .sold_out {
        color: grey !important;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/tickets/TicketDetailsList.vue